import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { EqualisationFeesFormValues } from './FormWrapper';
import { useEqualisationSection } from '../EqualisationContext';
import FeeCardRow from './FeeCardRow';

interface FeeCardProps {
  index: number;
  isLastElement: boolean;
  lpFeeTemplates: Array<{
    id: string;
    name: string;
  }>;
}

const FeeCard: React.FC<FeeCardProps> = ({
  index,
  isLastElement,
  lpFeeTemplates,
}) => {
  const { baseCurrency } = useEqualisationSection();
  const { control } = useFormContext<EqualisationFeesFormValues>();

  return (
    <Controller
      name={`totalCommitmentFees.${index}`}
      control={control}
      render={({ field: { value, onChange } }) => (
        <FeeCardRow
          index={index}
          isLastElement={isLastElement}
          lpFeeTemplates={lpFeeTemplates}
          value={value}
          baseCurrency={baseCurrency}
          onChange={onChange}
        />
      )}
    />
  );
};

export default FeeCard;
